<template>
  <div class="dashboard-widget-settings">

    <VQBForm
      v-if="localValue.vqb"
      v-model="localValue.vqb"
    ></VQBForm>
  </div>
</template>

<script>
import Builder from "@/components/report/builder/Builder.vue";
import VQBForm from "@/components/report/builder/VQBForm.vue";

export default {
  name: 'VQBTableWidgetDataSettings',
  components: {VQBForm, Builder},
  props: {
    value: { type: Object, required: true },
  },
  computed: {
    localValue: {
      get() {return this.value},
      set(value) {this.$emit('input', value)}
    }
  },
  data(){
    return {}
  },
  methods: {}
}
</script>